import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { DataHandler, FastFactCard } from 'C4';
import { storageKeys } from 'settings';

import APIHandler from 'config/APIHandler';

export default class FastFacts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fastFacts: [],
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      DataHandler.checkKey(storageKeys.fastFacts, APIHandler.getFastFacts(appId))
        .then((res) => {
          console.log(res);
          const startingValues = [];
          Object.keys(res).map(() => {
            const newObj = {};
            newObj.data = 0;
            newObj.pos = 20;
            return startingValues.push(newObj);
          });
          const fastFactsList = (
            <StaggeredMotion
              defaultStyles={startingValues}
              styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
                ? { data: spring(1, { stiffness: 320, damping: 28 }), pos: spring(0, { stiffness: 320, damping: 28 }) }
                : { data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }), pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
            >
              {styles => (
                <React.Fragment>
                  {res.map((fact, id) => {
                    const {
                      url, title, subtitle, image, type, itemID,
                    } = fact;

                    let newUrl = url;
                    let newImage = image;
                    if (url.includes(',')) {
                      newUrl = url.split(',');
                      [newImage] = newUrl;
                    }

                    if (fact.type) {
                      const key = id;
                      return (
                        <div key={key} className="fastfactsCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                          <FastFactCard
                            appId={appId}
                            image={image}
                            index={key}
                            key={key}
                            subtitle={subtitle}
                            title={title}
                            type={type}
                            url={newUrl}
                            itemID={itemID}
                          />
                        </div>
                      );
                    }
                    return null;
                  })}
                </React.Fragment>
              )}
            </StaggeredMotion>);
          this.setState({ fastFacts: fastFactsList });
        });
    });
  }

  render() {
    return (
      <div className="fastfacts__Grid">
        {this.state.fastFacts}
      </div>
    );
  }
}
